<template>
  <div v-if="show && site" class="modal-overlay" @click="$emit('close')">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h3>{{ $t('select_message') }}</h3>
        <button @click="$emit('close')" class="close-button" type="button">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div class="message-options">
          <button
            v-if="showNoCleanerArrival"
            @click="$emit('select', 'no_cleaner_arrival')"
            class="message-option"
            type="button"
          >
            <div class="message-preview">
              <p class="message-text">{{ $t('message_no_cleaner_arrival') }}</p>
            </div>
            <div class="message-info">
              <span class="info-badge">{{ $t('rooms_without_cleaner_arrival_percentage') }}: {{ site?.rooms_without_cleaner_arrival_percentage || 0 }}%</span>
            </div>
          </button>
          
          <button
            v-if="showOpenComplaints"
            @click="$emit('select', 'open_complaints')"
            class="message-option"
            type="button"
          >
            <div class="message-preview">
              <p class="message-text">{{ $t('message_open_complaints') }}</p>
            </div>
            <div class="message-info">
              <span class="info-badge">{{ $t('rooms_with_open_complaints_percentage') }}: {{ site?.rooms_with_open_complaints_percentage || 0 }}%</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageSelectionModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    site: {
      type: Object,
      default: null,
    },
  },
  computed: {
    showNoCleanerArrival() {
      if (!this.site) return false
      return this.site.criteria_type === 'no_cleaner_arrival' || this.site.criteria_type === 'both'
    },
    showOpenComplaints() {
      if (!this.site) return false
      return this.site.criteria_type === 'open_complaints' || this.site.criteria_type === 'both'
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/vars.scss' as *;

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background-color: $white;
  border-radius: 12px;
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.2);
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;

  h3 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: $font-weight-bold;
    color: $black-blue;
  }
}

.close-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: $dark-grey;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f5f5f5;
    color: $black-blue;
  }

  svg {
    width: 20px;
    height: 20px;
  }
}

.modal-body {
  padding: 24px;
  overflow-y: auto;
}

.message-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.message-option {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background-color: $white;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;

  &:hover {
    border-color: #25d366;
    box-shadow: 0 2px 8px rgba(37, 211, 102, 0.2);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
}

.message-preview {
  .message-text {
    margin: 0;
    font-size: 1rem;
    line-height: 1.6;
    color: $black-blue;
    white-space: pre-line;
  }
}

.message-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-badge {
  display: inline-block;
  padding: 4px 12px;
  background-color: #f5f5f5;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: $font-weight-semi-bold;
  color: $dark-grey;
}

@media (max-width: 768px) {
  .modal-content {
    max-width: 100%;
    margin: 10px;
  }

  .modal-body {
    padding: 16px;
  }
}
</style>
